import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { LeaderManagementPermissionsLoadAction } from '../../domains/leadersManagement/loadLeaderManagementPermissionsActions.types';

import { LeaderManagementPermissionsLifecycle } from './types';

export type LeaderManagementPermissionsAction = LeaderManagementPermissionsLoadAction;

const initialState: LeaderManagementPermissionsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<LeaderManagementPermissionsLifecycle, LeaderManagementPermissionsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'LEADER_MANAGEMENT_PERMISSIONS.LOAD_PENDING':
      return setPending();
    case 'LEADER_MANAGEMENT_PERMISSIONS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'LEADER_MANAGEMENT_PERMISSIONS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    default:
      return state;
  }
};

export default reducer;
